<!--
 * @Author: your name
 * @Date: 2021-06-24 09:57:36
 * @LastEditTime: 2021-09-06 14:08:58
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /visual-products-site-web/src/components/community/img_flex/img_flex_layout.vue
-->
<template>
  <div class="_width works">
    <!-- 自己的作品 -->
    <div class="_width _height"
         v-if="!this.userId">
      <div class=" _width"
           style="background:#fff;"
           v-if="loading_bool">
        <Loading :loading_bool="loading_bool"></Loading>
      </div>

      <div class=""
           v-if="!loading_bool&& own_works_data &&  own_works_data.length!==0">
        <div class="works_list _width"
             v-for="(item,index) in own_works_data"
             :key="index"
             :id="'shoplist'+index">

          <div class="tt _width">
            <div class="title_left">

              <router-link class="title "
                           :to="'/findDetail/'+item.topicId" style="font-weight: 600;">{{item.title}}
              </router-link>
              <div class="time" v-if="item.createTime">
                发布于 <span v-time="item.createTime"></span>
              </div>
            </div>
            <div class="title_right">
              <span class="type_ing" v-if="item.isChecked!==1"> {{ item.isChecked == 2 ? "待审核": item.isChecked == 4? "未通过": ""}}</span>
              <div class="delete">

                <el-popconfirm title="这个作品确定删除吗？"
                               @confirm="delete_works(item.topicId,index)">
                  <el-button icon="el-icon-delete" slot="reference">删除</el-button>
                </el-popconfirm>
              </div>


            </div>

            
          </div>

          <ul class="common_img cover_conter">
            <li v-for="(item_son, index_son) in item.topicTnList"
                :key="index_son"
                class="grid-img anmition_show">
              <router-link class="_width _height fl video_position"
                           :to="'/findDetail/'+item.topicId">
                <div class="cover_img"
                     v-if="item_son.tnUrl">
                  <img :src="item_son.tnUrl"
                       class="fade_image_out cover"
                       v-if="item_son.type==1"
                       alt="item_son.description">

                  <img :src="item_son.tnUrl"
                       v-if="item_son.type==2"
                       class="fade_image_out cover"
                       alt="item_son.description">
                  <div class="play_mose"
                       v-if="item_son.type==2">
                    <img src="@/assets/image/community/play.png"
                         alt="">
                  </div>
                </div>
              </router-link>

              <!-- 超出最多显示 更多图 -->
              <router-link class="img_num _width _height"
                           v-if="item.topicTnList.length > index_son+1  &&  index_son+1 ==8 "
                           :to="'/findDetail/'+item_son.topicId">
                +{{item.topicTnList.length - 8}}
              </router-link>

            </li>
          </ul>

          <div class="bottom_common _width">
            <!-- <div class="bottom_common_left ">
              <div class="delete">

                <el-popconfirm title="这个作品确定删除吗？"
                               @confirm="delete_works(item.topicId,index)">
                  <el-button icon="el-icon-delete" slot="reference">删除</el-button>
                </el-popconfirm>
              </div>

            </div> -->
            <!-- state -->
            <!-- <div class="state bottom_common_right">
              <ul>
                <li @click="getComments(item.topicId,index)"><i></i>{{item.replyCount}}</li>
                <li class="solid">|</li>
                <li @click="like(item.topicId,item.isFavor,'#shoplist'+index)"
                    :class="item.isFavor == 1 ? 'yes_like':''"><i></i>{{item.favorCount}}</li>
                <li class="solid">|</li>
                <li><i></i>{{item.viewCount}}</li>
              </ul>
            </div> -->
            <!-- state -->
            <div class="state bottom_common_right">
              <ul>
                <li @click="getComments(item.topicId,index)"
                    title="评论"><i></i>{{item.replyCount}}</li>
                <li @click="like(item.topicId,item.isFavor,index)"
                    title="点赞"
                    :class="item.isFavor == 1 ? 'yes_like':''"
                    class="like"><i></i>{{item.favorCount}}</li>
                <li title="浏览"><i></i>{{item.viewCount}}</li>
              </ul>
            </div>
            <!-- state -->

          </div>

          <!--评论开始-->

          <!--评论提交-->
          <div class="edit_comment of_h"
               v-show="showComment==index">
            <div class="entry of_h">

              <div class="photo fc_l"
                   v-if="is_show_common == false"
                   @click="on_ucenter(isLogin_user.id)">
                <img v-if="isLogin_user.headimg"
                     :src="isLogin_user.headimg">
              </div>

              <div class="photo fc_l"
                   v-if="is_show_common == true">
                <img src="@/assets/image/common/nan.png">
              </div>

              <div class="edit fc_l">
                <textarea placeholder="说点什么"
                          v-model="commentNr"></textarea>

                <div class="null_login_common"
                     v-if="is_show_common == true">请<a href="javascript:;"
                     v-ripple="'rgba(255, 255, 255, 0.25)'"
                     @click="on_login()">登录</a> 后再进行评论
                </div>
              </div>
            </div>
            <div class="submitBtn mt_15 of_h">
              <button type="button"
                      :class="commentNr?'fc_r on':'fc_r'"
                      @click="submitComment(item.topicId,index,1)">评论</button>
            </div>
          </div>

          <!--评论数据-->
          <div class="comments mt_15"
               v-show="showComment==index">
            <div class="title">全部评论<strong>{{item.replyCount}}</strong></div>
            <div class="content anmition_show">

              <div>

                <div class="box mt_15 of_h"
                     v-for="(replis,index) in comments"
                     :key="index">
                  <div class="photo fc_l">
                    <a href="javascript:;"
                       @click="on_ucenter(replis.userId)">
                      <img v-if="replis.headimg"
                           :src="replis.headimg">
                      <img v-else
                           src="@/assets/image/community/nophoto.png">
                    </a>
                  </div>
                  <div class="info fc_l">
                    <div class="name">{{replis.realname}}</div>
                    <div class="context">
                      {{replis.replyContent}}
                    </div>
                    <div class="time">
                      <!-- <strong>{{ replis.createTime | getMoment }}</strong> -->

                      <strong v-if="replis.createTime "
                              v-time="replis.createTime "></strong>
                    </div>
                  </div>
                </div>

              </div>
              <div class="morecomments"
                   @click="morecomments(item.topicId)"
                   v-show="comments.length< item.replyCount">加载更多评论...</div>
              <div class="nocomments"
                   v-show="comments.length > item.replyCount || comments.length == item.replyCount">没有更多评论了</div>
            </div>
          </div>
          <!--评论结束-->
        </div>
      </div>

      <div class="null_data"
           v-if="!loading_bool && own_works_data && own_works_data.length==0">
        <img src="@/assets/image/common/null_data.png"
             alt="">
        <p>暂无作品...</p>
      </div>

      <div class="Ufollowspage _width"
           style="background: none;padding:20px 0">

        <el-pagination background
                       :hide-on-single-page="true"
                       layout="prev, pager, next"
                       :current-page="page.current_page"
                       @current-change="handleCurrentChange_own"
                       :page-size="page.PageSize"
                       :total="page.total">
        </el-pagination>
      </div>

    </div>

    <!-- 别人的作品 -->
    <div class="_width _height"
         v-if="this.userId">

      <div class=" _width"
           style="background:#fff;"
           v-if="loading_bool">
        <Loading :loading_bool="loading_bool"></Loading>
      </div>

      <div class=""
           v-if="!loading_bool&& other_works_data &&  other_works_data.length!==0">
        <div class="works_list _width"
             v-for="(item,index) in other_works_data"
             :key="index"
             :id="'shoplist'+index">

          <router-link class="title _width"
                       :to="'/findDetail/'+item.topicId">{{item.title}}</router-link>
          <div class="time"  v-if="item.createTime">
            发布于 <span v-time="item.createTime"></span>
          </div>
          <ul class="common_img cover_conter">
            <li v-for="(item_son, index_son) in item.topicTnList"
                :key="index_son"
                class="grid-img anmition_show">
              <router-link class="_width _height fl video_position"
                           :to="'/findDetail/'+item.topicId">
                <div class="cover_img"
                     v-if="item_son.tnUrl">
                  <img :src="item_son.tnUrl"
                       class="fade_image_out cover"
                       v-if="item_son.type==1"
                       alt="item_son.description">

                  <img :src="item_son.tnUrl"
                       v-if="item_son.type==2"
                       class="fade_image_out cover"
                       alt="item_son.description">
                  <div class="play_mose"
                       v-if="item_son.type==2">
                    <img src="@/assets/image/community/play.png"
                         alt="">
                  </div>
                </div>
              </router-link>

              <!-- 超出最多显示 更多图 -->
              <router-link class="img_num _width _height"
                           v-if="item.topicTnList.length > index_son+1  &&  index_son+1 ==8 "
                           :to="'/findDetail/'+item_son.topicId">
                +{{item.topicTnList.length - 8}}
              </router-link>

            </li>

          </ul>

          <div class="bottom_common _width">
            <!-- state -->
            <div class="state bottom_common_right">
              <ul>
                <li @click="getComments(item.topicId,index)"
                    title="评论"><i></i>{{item.replyCount}}</li>
                <li @click="like(item.topicId,item.isFavor,index)"
                    title="点赞"
                    :class="item.isFavor == 1 ? 'yes_like':''"
                    class="like"><i></i>{{item.favorCount}}</li>
                <li title="浏览"><i></i>{{item.viewCount}}</li>
              </ul>
            </div>
            <!-- state -->

          </div>

          <!--评论开始-->

          <!--评论提交-->
          <div class="edit_comment of_h anmition_show"
               v-show="showComment==index">
            <div class="entry of_h">
              <!-- <div class="photo fc_l">
                <img :src="isLogin_user.headimg"
                     v-if="isLogin_user.headimg">
                <img src="@/assets/image/common/nan.png"
                     v-else>
              </div> -->

              <div class="photo fc_l"
                   v-if="is_show_common == false"
                   @click="on_ucenter(isLogin_user.id)">
                <img v-if="isLogin_user.headimg"
                     :src="isLogin_user.headimg">
              </div>

              <div class="photo fc_l"
                   v-if="is_show_common == true">
                <img src="@/assets/image/common/nan.png">
              </div>

              <div class="edit fc_l">
                <textarea placeholder="说点什么"
                          v-model="commentNr"></textarea>
                <div class="null_login_common"
                     v-if="is_show_common == true">请<a href="javascript:;"
                     v-ripple="'rgba(255, 255, 255, 0.25)'"
                     @click="on_login()">登录</a> 后再进行评论
                </div>
              </div>
            </div>
            <div class="submitBtn mt_15 of_h">
              <button type="button"
                      :class="commentNr?'fc_r on':'fc_r'"
                      @click="submitComment(item.topicId,index,2)">评论</button>
            </div>
          </div>

          <!--评论数据-->
          <div class="comments mt_15 anmition_show"
               v-show="showComment==index">
            <div class="title">全部评论<strong>{{item.replyCount}}</strong></div>
            <div class="content">

              <div>

                <div class="box mt_15 of_h"
                     v-for="(replis,index) in comments"
                     :key="index">
                  <div class="photo fc_l"
                       @click="on_ucenter(replis.userId)">
                    <img :src="replis.headimg">
                  </div>

                  <div class="info fc_l">
                    <div class="name">{{replis.realname}}</div>
                    <div class="context">
                      {{replis.replyContent}}
                    </div>
                    <div class="time">
                      <!-- <strong>{{ replis.createTime | getMoment }}</strong> -->

                      <strong v-if="replis.createTime "
                              v-time="replis.createTime "></strong>
                    </div>
                  </div>
                </div>

              </div>
              <div class="morecomments"
                   @click="morecomments(item.topicId)"
                   v-show="comments.length< item.replyCount">加载更多评论...</div>
              <div class="nocomments"
                   v-show="comments.length > item.replyCount || comments.length == item.replyCount">没有更多评论了</div>
            </div>
          </div>
          <!--评论结束-->

        </div>
      </div>

      <div class="null_data"
           v-if="!loading_bool && other_works_data && other_works_data.length==0">
        <img src="@/assets/image/common/null_data.png"
             alt="">
        <p>暂无作品...</p>
      </div>

      <div class="Ufollowspage _width"
           style="background: none;padding:20px 0">
        <el-pagination background
                       :hide-on-single-page="true"
                       layout="prev, pager, next"
                       :current-page="page2.current_page"
                       @current-change="handleCurrentChange_other"
                       :page-size="page2.PageSize"
                       :total="page2.total"></el-pagination>
      </div>

    </div>

  </div>
</template>

<script>
import VueBarrel from '@/components/community/img_flex/VueBarrel.vue'
import Loading from '@/components/loading/loading.vue'
import {
  ta_works,
  circle_favorTopic,
  me_works,
  works_like,
  delete_list
} from '@/utils/api/ucenter.js' //作品数据//点赞
import { Info } from '@/utils/api/login.js'
import { getMoment } from '@/modules/time.js'
import '@/modules/time2.js'

import {
  selectReplise,
  replyTopic,
  favorTopic,
  integral
} from '@/utils/api/circleDetail.js'


export default {
  data () {
    return {
      showComment: -1, //展开评论
      //评论
      showComment: -1, //展开评论
      Replise: {},
      Replisetimes: 0, //评论数	  
      comments: [],
      commentsparames: {
        topicId: "",
        current: 1,
        size: 3
      },
      commentNr: "", //评论内容

      //当前用户信息
      user: {
        headimg: "",
        id: "",
        realname: ""
      },


      loading_bool: true, //加载loading
      own_works_data: [], //自己作品数据
      other_works_data: [], //别人作品数据

      page: {
        total: 0,
        current_page: 1, //默认第一页
        PageSize: 10,
      },
      page2: {
        total: 0,
        current_page: 1, //默认第一页
        PageSize: 10,
      },
      value: '',
      value2: '',

      circleId: '',

      is_show_common: true,
      isLogin_user: {},
    }
  },

  //注册过滤器
  filters: {
    getMoment
  },

  computed: {
    // dateValue () {
    //   return (val) => {
    //     return this.$moment(val).fromNow();
    //     // return this.$moment(val).startOf('hour').fromNow();
    //   }
    // }
  },
  created () {
    this.router_url = this.$route.fullPath;

    this.is_login();//是否登陆

    //获取当前用户信息
    this.user.headimg = localStorage.getItem("headimg");
    this.user.id = localStorage.getItem("id");
    this.user.realname = localStorage.getItem("realname");

    let userId = this.$route.params && this.$route.params.id;
    this.userId = userId;
    if (this.userId) {
      let params = {
        userId: this.userId,
        current: this.page2.current_page,
        size: this.page2.PageSize,
      }
      this.other_works(params) //别人作品接口
    } else {
      let params = {
        current: this.page.current_page,
        size: this.page.PageSize,
      }
      this.own_works(params) //自己作品
    }

  },

  methods: {
    // 点击头像
    on_ucenter (authorId) {
      // 如果是自己
      if (this.isLogin_user.id && this.isLogin_user.id == authorId) {
        let routeData = this.$router.resolve({ path: '/Pcenter?type=0' })
        window.open(routeData.href, '_blank');
        // this.$router.push({ path: '/Pcenter?type=0' })
      } else {
        // 如果不是自己
        // this.$router.push({ path: '/Ucenter/' + authorId })

        let routeData = this.$router.resolve({ path: '/Ucenter/' + authorId })
        window.open(routeData.href, '_blank');
      }
    },


    // 点击返回登录
    on_login () {
      sessionStorage.setItem('router_url', this.router_url)//活动详情
      this.$router.push(
        {
          path: '/login/?state=' + 1,
        }
      )
    },



    // 是否登录
    is_login () {
      Info().then((res) => {
        let data = res.data;
        this.isLogin = data.isLogin
        if (this.isLogin == true) {
          this.is_show_common = false
          this.isLogin_user = data.user
        }
      })
    },

    //积分
    post_integral (type) {
      integral(type).then((res) => {
        let data = res.data;
        // console.log(data);
        // if (data.status !== 200) {
        //   this.$message.error(data.message);
        // }
      });
    },

    //提交评论
    submitComment (topId, index, type) {

      // let userid = localStorage.getItem("id"),
      //   headimg = localStorage.getItem("headimg");
      // if (userid && headimg) {
      //this.loading_bool = true;

      // 未登录就去登录
      if (this.isLogin == true) {
        let parame = {
          topicId: topId,
          replyContent: this.commentNr
        };
        if (this.commentNr) {
          replyTopic(parame).then((res) => {
            if (res.data.code == 200) {
              this.commentNr = "";
              this.$message({
                message: '评论信息提交成功!',
                type: 'success'
              });

              if (type == 1) {
                this.own_works_data[index].replyCount = this.own_works_data[index].replyCount + 1
              } else {
                this.other_works_data[index].replyCount = this.other_works_data[index].replyCount + 1
              }


              this.commentsparames.current = 1,
                this.commentsparames.topicId = topId;
              this.commentsparames.size = this.comments.length + 1;
              this.comments = [],
                this.getSelectReplise(this.commentsparames);//评论的接口

              // let params2 = {
              //   userId: this.userId,
              //   current: 1,
              //   size: 10,
              // };
              // this.other_works(params2); //作品接口

              // 请求积分的借口
              let prames = {
                type: '1',
                code: '203',
              }
              this.post_integral(prames);
            } else {
              this.$message({
                message: "评论信息提交失败!",
                type: 'error'
              });
            }
          })
        }
      } else {
        sessionStorage.setItem('router_url', this.router_url)//活动详情
        this.$router.push(
          {
            path: '/login/?state=' + 1,
          }
        )
      }
    },
    //展开评论
    getComments (topId, index) {
      this.comments = [],
        this.commentsparames.current = 1,
        this.commentsparames.topicId = topId;
      if (this.showComment != index) {
        this.showComment = index;
        this.getSelectReplise(this.commentsparames);
      } else {
        this.comments = [],
          this.showComment = -1;
      }
    },

    //获取评论数据
    getSelectReplise (parames) {
      selectReplise(parames).then((res) => {
        console.log(res);
        this.Replise = res.data.data;
        if (!this.Replise.records) {
          return
        };
        this.Replise.records.forEach((item) => {
          this.comments.push(item)
        });
      });
    },
    //加载更多评论
    morecomments (topId) {
      //this.loading_bool = true;
      this.commentsparames.topicId = topId;
      this.commentsparames.current = this.commentsparames.current + 1;
      this.getSelectReplise(this.commentsparames);
    },

    //获取自己作品数据
    own_works (name, index) {
      this.loading_bool = true;
      me_works(name).then((res) => {
        let data = res.data;
        this.own_works_data = data.data.records;

        //分页
        this.page.total = data.data.total; //全部数据
        this.page.current_page = data.data.current; //默认第一页
        this.page.PageSize = data.data.size //每页条数
        this.loading_bool = false;
        this.$emit('update_data', true) //传父组件 让腹组件更新导航数据
        // if (this.other_works_data && index) {
        //   document.querySelector(index).scrollIntoView(true)
        //   var auchor = this.$el.querySelector(index)
        //   document.body.scrollTop = auchor.offsetTop
        // }
      })
//       this.own_works_data = [
//         {
//           topicId: "5f06512881171e54c95f6bd8344bf798",
//           circleId: "3e1fe1451b27ae6178e0f5b5cdb25e46",
//           auditorContent: null,
// authorId: "83056ebdfce64888a97c2c9fe2529228",
// circleId: "3e1fe1451b27ae6178e0f5b5cdb25e46",
// collectionCount: 0,
// createTime: "2022-09-16T06:57:59.000+00:00",
// description: "小兔子爱吃萝卜、爱吃菜",
// favorCount: 1,
// forumId: "ba2b17d713a14590a80687358c21b1d3",
// handleTime: null,
// hasImage: 1,
// hasVideo: 0,
// headimg: "https://v-pic.jingjiribao.cn/uploadPics/head/333ef18c7b6b4f3c8c519bd5c8855ec0.jpg",
// id: null,
// isChecked: 2,
// isFavor: 1,
// isFollow: 0,
// isTop: 0,
// lastTime: "2022-09-16T06:57:59.000+00:00",
// mark: null,
// rbacId: null,
// realname: "宁静致远",
// recommend: 0,
// replyCount: 0,
// sortNo: 0,
// tags: "",
// title: "可爱的小兔子",
// tnUrl: null,
// topTime: null,
// topicId: "9f9e54bd18172b1c2ef813a6dc86ede1",
// topicTn: null,
// topicTnList: [{
//   description: "灯光下的月亮",
// sortNo: null,
// tnId: "1b18b511570b8a85ff2761be976caab5",
// tnUrl: "https://v-pic.jingjiribao.cn/community/topic/20220916/05be7c86f96c41369d151d29c887bbbc_s.jpg",
// topicId: "5f06512881171e54c95f6bd8344bf798",
// topicUrl: "https://v-pic.jingjiribao.cn/community/topic/20220916/05be7c86f96c41369d151d29c887bbbc.jpg",
// type: 1

// },
// {
//   description: "彩霞",
// sortNo: null,
// tnId: "73549b8a9458e277ec8bd4ac4f2c84cd",
// tnUrl: "https://v-pic.jingjiribao.cn/community/topic/20220916/4730e5e5580f44ab8a0449f209b9ff2d_s.jpg",
// topicId: "5f06512881171e54c95f6bd8344bf798",
// topicUrl: "https://v-pic.jingjiribao.cn/community/topic/20220916/4730e5e5580f44ab8a0449f209b9ff2d.jpg",
// type: 1
// }],
// topicUrl: null,
// type: 1,
// viewCount: 3
//         }
//       ]
//         this.loading_bool = false;
//         this.$emit('update_data', true) //传父组件 让腹组件更新导航数据
    },


    //获取别人作品数据
    other_works (name, index) {
      this.loading_bool = true;
      ta_works(name, index).then((res) => {
        let data = res.data;
        this.other_works_data = data.data.records


        //分页
        this.page2.total = data.data.total; //全部数据
        this.page2.current_page = data.data.current; //默认第一页
        this.page2.PageSize = data.data.size //每页条数
        this.loading_bool = false;
        this.$emit('update_data', true) //传父组件 让腹组件更新导航数据

        // if (this.other_works_data && index) {
        //   document.querySelector(index).scrollIntoView(true)
        //   var auchor = this.$el.querySelector(index)
        //   document.body.scrollTop = auchor.offsetTop
        // }

      })
    },


    // 点击自己分页
    handleCurrentChange_own (val) {
      this.page.current_page = val
      let params1 = {
        current: this.page.current_page,
        size: 10,
      }
      this.own_works(params1); ///刷新粉丝列表
      window.scrollTo(0, 430);
    },
    // 点击别人分页
    handleCurrentChange_other (val2) {
      this.page2.current_page = val2
      let params2 = {
        userId: this.userId,
        current: this.page2.current_page,
        size: this.page2.PageSize,
      }
      this.other_works(params2); ///刷新粉丝列表




      window.scrollTo(0, 430);
    },

    // 点赞
    like (id, isFavor, index) {
      // 未登录就去登录
      if (this.isLogin == true) {
        let params = {
          userId: this.userId,
          topicId: id,
        }
        works_like(params).then((res) => {
          let data = res.data;
          // 点赞成功
          if (data.code == 200 && isFavor == 0) {
            this.$message({
              message: '点赞成功',
              type: 'success'
            });
            // 别人的列表
            if (this.userId) {
              this.other_works_data[index].isFavor = 1
              this.other_works_data[index].favorCount = this.other_works_data[index].favorCount + 1

              // let params2 = {
              //   userId: this.userId,
              //   current: this.page2.current_page,
              //   size: this.page2.PageSize,
              // }
              // this.other_works(params2); ///刷新粉丝列表

              // 请求积分的借口
              let prames = {
                type: '1',
                code: '203',
              }
              this.post_integral(prames);

              //自己
            } else {
              this.own_works_data[index].isFavor = 1
              this.own_works_data[index].favorCount = this.own_works_data[index].favorCount + 1

              // let params1 = {
              //   current: this.page.current_page,
              //   size: 10,
              // }
              // this.own_works(params1); ///刷新粉丝列表
              // window.scrollTo(0, 430);
              // 请求积分的借口
              let prames = {
                type: '1',
                code: '203',
              }
              this.post_integral(prames);

            }

          }
          // 取消点赞成功
          if (data.code == 200 && isFavor == 1) {
            this.$message({
              message: '取消点赞成功',
              type: 'success'
            })
            // 别人的列表
            if (this.userId) {
              this.other_works_data[index].isFavor = 0
              this.other_works_data[index].favorCount = this.other_works_data[index].favorCount - 1

              // let params2 = {
              //   userId: this.userId,
              //   current: this.page2.current_page,
              //   size: this.page2.PageSize,
              // }
              // this.other_works(params2); ///刷新粉丝列表


              // 自己
            } else {
              this.own_works_data[index].isFavor = 0
              this.own_works_data[index].favorCount = this.own_works_data[index].favorCount - 1

              // let params1 = {
              //   current: this.page.current_page,
              //   size: 10,
              // }
              // this.own_works(params1); ///刷新粉丝列表


            }
          }
        })
      } else {
        sessionStorage.setItem('router_url', this.router_url)//活动详情
        this.$router.push(
          {
            path: '/login/?state=' + 1,
          }
        )
      }
    },
    // 删除
    delete_works (id, index) {
      let params = {
        topicId: id
      }
      delete_list(params).then((res) => {
        let data = res.data;
        // console.log(data);
        this.$message({
          message: '删除作品成功!',
          type: 'success'
        });
        this.own_works_data.splice(index, 1)//删除一个元素

        // let params1 = {
        //   current: this.page.current_page,
        //   size: 10,
        // }
        // this.own_works(params1); ///刷新粉丝列表
        this.$emit('update_data', true) //传父组件 让腹组件更新导航数据
      })
    },





  },
  components: {
    VueBarrel,
    Loading
  },

}
</script>
<style >
.el-button--primary {
  color: #fff !important;
  background-color: #d4011a !important;
  border-color: #d4011a !important;
}
.el-button--text {
  color: #d4011a !important;
}
.el-button--primary:focus,
.el-button--primary:hover {
  color: #fff !important;
  background-color: #d4011a !important;
  border: 1px solid #d4011a !important;
}
</style>


<style lang="scss" scoped>
@import "../../../assets/css/community/img_flex_layout.css";
.works >>> .el-button {
  font-size: 0.14rem;
  cursor: pointer;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0.02rem;
  color: rgb(48, 129, 251);
  font-family: "PingFang SC", "Lantinghei SC", "Microsoft YaHei", "HanHei SC",
    "Helvetica Neue", "Open Sans", Arial, "Hiragino Sans GB", "微软雅黑",
    STHeiti, "WenQuanYi Micro Hei", SimSun, sans-serif;
  transition: all 0.3s;
  border: none;
}
.works >>> .el-button:hover {
  background-color: #fff;
}

// 未登录
.null_login_common {
  width: 100%;
  height: 100%;
  backdrop-filter: saturate(10%) blur(10px);
  -webkit-backdrop-filter: blur(10px);
  background-color: rgba(0, 0, 0, 0.05);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.16rem;
  color: #666;
  position: absolute;
  top: 0;
  left: 0;
}

.null_login_common a {
  color: #c00;
  border: none;
  display: block;
  margin: 0 3px;
  text-align: center;
  border-bottom: 1px solid #c00;
}

.video_position {
  position: relative;
}

.play_mose {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
}
.play_mose img {
  width: 0.6rem;
}

.like:hover {
  color: #c00;
}

.bottom_common_right li:nth-child(1):hover {
  color: #c00;
  cursor: pointer;
}

.bottom_common_right li:nth-child(1):hover i {
  background-position: 8px -20px !important;
  cursor: pointer;
}

.Ufollowspage {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 0 20px;
  background: #ffff;
  box-sizing: border-box;
}

div.edit_comment div.entry div.photo {
  width: 0.6rem;
  height: 0.6rem;
}

div.edit_comment div.entry div.photo img {
  display: block;
  width: 0.6rem;
  height: 0.6rem;
  border-radius: 30px;
}

div.edit_comment div.entry div.edit {
  width: calc(100% - 0.7rem);
  margin-left: 0.1rem;
  position: relative;
  border-radius: 3px;
  overflow: hidden;
}

div.edit_comment div.entry div.edit textarea {
  width: 100%;
  height: 0.6rem;
  line-height: 20px;
  font-size: 0.14rem;
  border-radius: 4px;
  border: 1px #ddd solid;
  background: #eee;
  padding: 0.1rem;
  box-sizing: border-box;
  transition: all 0.3s;
}
div.edit_comment div.entry div.edit textarea:focus,
div.edit_comment div.entry div.edit textarea:hover {
  background: #fff;
}

div.submitBtn {
  padding-right: 0;
}

div.submitBtn button {
  display: inline-block;
  width: 1rem;
  height: 0.36rem;
  line-height: 36px;
  text-align: center;
  background: #eee;
  color: #bbb;
  border: 0;
  font-size: 0.14rem;
  border-radius: 4px;
}

div.submitBtn button.on {
  background: #c00;
  color: #fff;
}

div.comments {
}

div.comments div.title {
  height: 40px;
  line-height: 40px;
  padding: 0 20px;
  font-size: 14px;
}

div.comments div.title strong {
  font-family: "PingFang SC", "Lantinghei SC", "Microsoft YaHei", "HanHei SC",
    "Helvetica Neue", "Open Sans", Arial, "Hiragino Sans GB", "微软雅黑",
    STHeiti, "WenQuanYi Micro Hei", SimSun, sans-serif;
  padding: 0 10px;
}

div.comments div.content {
  padding: 0 20px 0px 20px;
}

div.comments div.content div.box {
  border-bottom: 1px #eee solid;
  padding-bottom: 15px;
}

div.comments div.content div.box div.photo {
  width: 60px;
  height: 60px;
}

div.comments div.content div.box div.photo img {
  display: block;
  width: 60px;
  height: 60px;
  border-radius: 30px;
}

div.comments div.content div.box div.info {
  width: 738px;
  padding-left: 15px;
}

div.comments div.content div.box div.info div.name {
  height: 25px;
  line-height: 25px;
  font-size: 14px;
  font-weight: bold;
  color: #333;
  margin-bottom: 22px;
}

div.comments div.content div.box div.info div.time {
  height: 25px;
  line-height: 25px;
  color: #c0c0c0;
  font-size: 14px;
  margin-bottom: 10px;
}

div.comments div.content div.box div.info div.time strong {
  color: #666;
  font-family: Arial;
  font-family: "PingFang SC", "Lantinghei SC", "Microsoft YaHei", "HanHei SC",
    "Helvetica Neue", "Open Sans", Arial, "Hiragino Sans GB", "微软雅黑",
    STHeiti, "WenQuanYi Micro Hei", SimSun, sans-serif;
}

div.comments div.content div.box div.info div.context {
  line-height: 25px;
  color: #737373;
  font-size: 14px;
  margin-bottom: 22px;
}

div.nocomments {
  height: 60px;
  line-height: 60px;
  text-align: center;
  color: #bbb;
  font-size: 14px;
}

div.morecomments {
  height: 60px;
  line-height: 60px;
  text-align: center;
  color: #888;
  font-size: 14px;
  cursor: pointer;
}
div.morecomments:hover {
  color: #f00;
}

.yes_like i {
  background-position: 8px -20px !important;
}

// 画廊
.cover_conter {
  display: flex;
  flex-wrap: wrap;
}

// 封面
.cover {
  height: 100%;
  width: 100%;
  max-height: 894px;
  min-width: 100%;
  -o-object-fit: cover;
  object-fit: cover;
  -webkit-transition: all 0.35s;
  transition: all 0.35s;
  background-color: #eee;
}

.grid-img div {
  height: 100%;
}

.grid-img div:hover img {
  -webkit-transform: scale(1.04);
  transform: scale(1.04);
  cursor: pointer;
}

// 更多数量
.img_num {
  position: absolute;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.4);
  font-size: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}

.grid-img {
  position: relative;
  display: inline-block;
  width: 417px;
  height: 417px;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  overflow: hidden;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;

  &:only-child {
    width: 417px;
    height: auto;
    box-sizing: border-box;
  }

  &:nth-child(3n + 1):nth-last-child(2),
  &:nth-child(3n + 2):last-child {
    width: 417px;
    height: auto;
  }

  &:nth-child(3n + 2) {
    margin: 0 6px;
  }
  &:nth-child(n + 4) {
    margin-top: 6px;
  }
  &:last-child {
    margin-right: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/community/img_flex/img_flex_layout.vue